import React from "react";
import PageHeading from "../utils/PageHeading";
import useShopStore from "../store/useShopStore";
import { useEffect } from "react";
import ProductCard from "../components/ProductCard";

import GridCardContainer from "../utils/GridCardContainer";
import Spinner from "../utils/Spinner";
export default function Wine() {
  const { getByCategory, wine } = useShopStore((state) => state);
  const urlparams = document.URL.split("#/").at(1);
  useEffect(() => {
    getByCategory(urlparams);
  }, [getByCategory, urlparams]);

  return (
    <div>
      <PageHeading>Wine</PageHeading>
      {!wine && <Spinner />}
      <GridCardContainer>
        {wine &&
          wine.map((product) => {
            return (
              <ProductCard
                image={product.image}
                title={product.name}
                category={product.category}
                price={product.price}
                key={product._id}
                id={product._id}
              />
            );
          })}
      </GridCardContainer>
    </div>
  );
}
